export function ConcatName(data: any): string {
  if (!data) {
    return null;
  }

  let { firstName, middleName, lastName } = data;

  return [firstName, middleName, lastName]
    .filter((name: string) => !!name)
    .join(' ');
}

/**
 * @NOTE: this is basically the polyfill is used by the object spread operator
 * I built it out here so we didn't need to import the polyfill globally and
 * I didn't have to redesign the pattern, if we ever bring in the object-rest operator
 * we should remove this and just go for that
 *
 * Object-rest
 * const { A, B, C, ...D } = { A: 'a', B: 'b', C: 'c', X: 'x', Y: 'y', Z: 'z' }
 *  the (...D) => D = { X: 'x', Y: 'y', Z: 'z' };
 * polyfill
 * const { A, B, C, rest } = __rest({ A: 'a', B: 'b', C: 'c', X: 'x', Y: 'y', Z: 'z' }, 'A', 'B', 'C')
 * now (rest) is assigned what (...D) recieved in the prev example
 * @param object any object with keys that correspond to @param keys
 * @param keys a string of keys on @param object
 * @return new object = { key[0], ... key[n-1], rest: { (remaining keys from object) }}
 */
export function __rest(object: any, keys: string[]): any {
  const ret: any = {};
  for (const key in object) {
    if (keys.indexOf(key) >= 0) {
      ret[key] = object[key];
    } else {
      if (!ret.rest) { ret.rest = {}; }
      ret.rest[key] = object[key];
    }
  }
  return ret;
}

/**
 * converts "SomethingLikeThis" to "Something Like This"
 * @param string expected format camelCase
 * @return string in "Title Case"
 */
export function camelCaseToTitleCase(string) {
  let ret = string[0];

  for (let i = 1; i < string.length; ++i) {
    let char = string[i];

    if (char.match(/[A-Z]/)) {
      ret += ` ${char}`;
    } else {
      ret += char;
    }
  }

  return ret;
}

/**
 * Detect iOS by navigator platform
 */
export function isIOS(): boolean {
  const navigator = window.navigator || { platform: '' };
  return ['iPad', 'iPhone', 'iPod'].indexOf(navigator.platform) >= 0;
}

/**
 * Capture body-scroll on iOS devices and prevents movement while also setting
 * style={ overflow: ["hidden"|"auto"] }
 * @param canScroll Turn body scrolling on-off w/ true-false
 */
export function bodyScroll(canScroll: boolean): void {
  if (canScroll) {
    document.body.style.overflow = 'auto';
    // @NOTE: removed this event listener as it locks up the entire app,
    // including scroll-spy modals (which is bad, obviously)
    // document.body.removeEventListener('touchmove', freeze, false);
  } else {
    document.body.style.overflow = 'hidden';
    // document.body.addEventListener('touchmove', freeze, false);
  }
}

/**
 * freeze() must exist outside of the bodyScroll()to keep the object-reference
 * otherwise it would not match up and it wouldn't be removable
 * @param touchEvent
 */
function freeze(touchEvent: TouchEvent) {
  touchEvent.preventDefault();
}

/**
 * Converts to an number with no decimal places.
 * Returns null if input is not a valid number.
 * Trims off decimal places if any exist in input.
 * @param val String value to convert to number.
 */
export function toInteger(val: string) {
  return val != '' && !isNaN(val as any) ? parseInt(val, 10) : null;
}
